<template>
    <v-dialog
        v-model="showPopUp"
        persistent
        data-cy="accessUpdatedPopUp"
        max-width="550"
    >
        <div class="grid-item">
            <v-row
                class="ma-0 px-0 pb-2 pt-0 border-bottom center-container-vertically"
            >
                <p class="h400 center-align-text">
                    {{ t("alerts.authenticationRequired") }}
                </p>
            </v-row>

            <v-row class="ma-0 px-0 pt-2">
                {{ t("alerts.accessUpdated") }}
            </v-row>

            <v-row
                class="mx-0 mt-2 px-0 pt-2 pb-4 d center-container-vertically"
            >
                <default-button
                    btn-style="default-btn small-default-btn primary-btn"
                    @run-method="handleLogout()"
                    data-cy="confirm"
                    text-style="h200 white-text"
                    text="Log out"
                />
            </v-row>
        </div>
    </v-dialog>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { signOut } from "aws-amplify/auth";
import { usePiniaStore } from "@/stores/store";
import { useOrganisationStore } from "@/stores/organisationStore";

import defaultButton from "@/components/buttons/defaultButton.vue";
import { redirectToRoute } from "@/router";
import { AuthRouteNames } from "@/constants/routes";

const { t } = useI18n();
const pStore = usePiniaStore();
const organisationStore = useOrganisationStore();

const props = defineProps<{
    dialogVisible: boolean;
}>();

const emit = defineEmits(["update:dialogVisible"]);

const showPopUp = computed({
    get: () => props.dialogVisible,
    set: (value) => emit("update:dialogVisible", value),
});

const handleLogout = async () => {
    pStore.setIsAuthenticated(false);
    try {
        await signOut({ global: true });
    } finally {
        organisationStore.clearOrganisationContext(pStore.getUserEmail);
        showPopUp.value = false;
        redirectToRoute({ name: AuthRouteNames.LOGIN });
    }
};
</script>
